export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f1feb4299b122440bd7adf159fa3abbf95fb514a2&name=fetchTypeahead!'